import "./application.css";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { NotFound } from "@/components/not-found";
import { routeTree } from "@/routeTree.gen";

/*
 * `defaultNotFoundComponent` is the whole not-found story (FR-014). Rails'
 * catch-all serves this same SPA shell for every non-XHR HTML path, so a
 * mistyped address reaches the router rather than a server error page, matches
 * no route, and lands here — inside the root route's `<Outlet />`, which is
 * what gives the not-found page the site's header and theme for free.
 */
const router = createRouter({ routeTree, defaultNotFoundComponent: NotFound });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>,
  );
}
